import { Extension, InputRule } from '@tiptap/core';
import { wrappingInputRule } from '@tiptap/core';

function createListHandler(editor, listCommandName, getAttrsFn) {
  return ({ state, range, match }) => {
    const { tr } = state;

    // Remove marker characters including the newline from the hard break
    tr.delete(range.from, range.to);

    // Create paragraph break at cursor position
    tr.split(range.from);

    tr.scrollIntoView();

    // Defer list creation to next tick to ensure stable document state
    window.setTimeout(() => {
      const attrs = getAttrsFn ? getAttrsFn(match) : {};

      if (listCommandName === 'bulletList') {
        editor.commands.toggleBulletList();
      } else if (listCommandName === 'orderedList') {
        editor.commands.toggleOrderedList(attrs);
      }
    }, 0);

    return tr;
  };
}

export const HardBreakToList = Extension.create({
  name: 'HardBreakToList',

  addInputRules() {
    return [
      // Convert "- " after hardBreak to bullet list
      new InputRule({
        find: /\n([-+*])\s$/,
        handler: createListHandler(this.editor, 'bulletList'),
      }),
      // Convert "1. " after hardBreak to ordered list
      new InputRule({
        find: /\n(\d+)\.\s$/,
        handler: createListHandler(this.editor, 'orderedList', match => {
          const start = Number.parseInt(match[2], 10);
          return start === 1 ? {} : { start };
        }),
      }),
      // Convert "1) " after hardBreak to ordered list
      new InputRule({
        find: /\n(\d+)\)\s$/,
        handler: createListHandler(this.editor, 'orderedList', match => {
          const start = Number.parseInt(match[2], 10);
          return start === 1 ? {} : { start };
        }),
      }),
      // Convert "1) " in general text to ordered list
      wrappingInputRule({
        find: /^(\d+)\)\s$/,
        type: this.editor.schema.nodes.orderedList,
        getAttributes: match => ({ start: +match[1] }),
        joinPredicate: (match, node) =>
          node.childCount + node.attrs.start === +match[1],
      }),
    ];
  },
});
